import { RIGA_TIMEZONE } from '@/utils/constants/date'

export const useCurrentTime = () => {
  const dayjs = useDayjs()

  const getCurrentTime = async () => {
    const { data: serverTime } = await useFetch<{ time: string }>('/api/server-time')

    const timeValue = serverTime.value?.time || dayjs.utc().toISOString()

    return dayjs.utc(timeValue).tz(RIGA_TIMEZONE).toISOString()
  }

  return {
    getCurrentTime
  }
}
